import { blue } from "@ant-design/colors";
import MiniInfoCard from "@lib/components/MiniComponents/Dashboard/MiniInfoCard";
import { PiPersonArmsSpreadFill } from "react-icons/pi";
import { FormattedMessage, useIntl } from "react-intl";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiGetCustomerLeads } from "@lib/api/customerLead";
import { useTypedSelector } from "@lib/redux";
import { ROUTES } from "@lib/constants";
import { AppCardProps } from "@lib/components/AppComponents/AppCard";

type Props = {
  cardProps?: AppCardProps;
};

export default function WhiteLabelLeadMiniCard(props: Props) {
  const { cardProps } = props;
  const { messages } = useIntl();
  const navigate = useNavigate();
  const { selectedCustomer } = useTypedSelector((state) => state.cache);

  const { data, isLoading } = useQuery({
    queryKey: [
      "dashboard-minicard-customer-leads",
      {
        customerId: selectedCustomer?.id,
      },
    ],
    queryFn: () =>
      apiGetCustomerLeads({
        filter: [
          ...(selectedCustomer?.id
            ? [`customerId||eq||${selectedCustomer.id}`]
            : []),
        ],
      }),
  });
  const apiData = data?.data?.data || [];

  const total = apiData.length;
  const newTotal = apiData.filter((d) => {
    const createdAt = dayjs(d.createdAt);
    const startOfMonth = dayjs().startOf("month");
    const endOfMonth = dayjs().endOf("month");

    return createdAt.isBetween(startOfMonth, endOfMonth, null, "[]");
  });

  const handleNavigate = () => {
    navigate(ROUTES.ADMIN.CUSTOMER_LEAD.LIST);
  };

  return (
    <MiniInfoCard
      loading={isLoading}
      navigate={handleNavigate}
      cardProps={cardProps}
      data={{
        icon: <PiPersonArmsSpreadFill />,
        color: blue[5],
        desc: (
          <FormattedMessage
            id="common.totalX"
            values={{ x: messages["common.customerLead"] as string }}
          />
        ),
        title: total,
        rightMenu: {
          key: "new",
          data: {
            data: newTotal.length,
            duration: messages["common.thisMonth"] as string,
          },
        },
      }}
    />
  );
}
